import React, { FC } from 'react'
import { Modal, Row, Col } from 'antd'
import { useHideModal } from 'components/Modals'
import { useTheme } from 'styled-components'
import Styled from './styled'
import { useScreenMatch } from 'theme/hooks'

export interface ITutorialModal {
	instructions: string
	title: string
	url: string
	onClose: () => Promise<void>
}

const TutorialModal: FC<ITutorialModal> = ({ title, url, onClose }) => {
	const theme = useTheme()
	const hideModal = useHideModal()
	const match = useScreenMatch()
	const closeModal = async () => {
		await onClose()
		hideModal()
	}

	return (
		<Modal title={title} width={match.gte('xl') ? 1200 : 800} open onCancel={closeModal} footer={null}>
			<Row gutter={[theme.margins.sm, theme.margins.lg]}>
				<Col lg={24}>
					<Styled.VideoContainer>
						<video width="100%" autoPlay controls>
							<source src={url} type="video/mp4" />
						</video>
					</Styled.VideoContainer>
				</Col>
			</Row>
		</Modal>
	)
}

export default TutorialModal
